import { render, staticRenderFns } from "./AffiliatePayoutsPage.vue?vue&type=template&id=fd215e68&scoped=true&lang=pug&"
import script from "./AffiliatePayoutsPage.vue?vue&type=script&lang=js&"
export * from "./AffiliatePayoutsPage.vue?vue&type=script&lang=js&"
import style0 from "./AffiliatePayoutsPage.vue?vue&type=style&index=0&id=fd215e68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd215e68",
  null
  
)

export default component.exports